export default function() {
  return [
    {
      title: "Dashboard",
      dev: false,
      to: {
        name: "dashboard"
      },
      htmlBefore: '<i class="material-icons">home</i>',
      htmlAfter: ""
    },
    {
      title: "Orders",
      htmlBefore: '<i class="material-icons">receipt</i>',
      dev: false,
      to: {
        name: "orders"
      },
      pages: [
        {
          title: "Statuses",
          dev: false,
          to: {
            name: "order_statuses"
          }
        }
      ]
    },
    // {
    //   title: 'Customers',
    //   htmlBefore: '<i class="material-icons">people</i>',
    //   to: {
    //     name: 'customers',
    //   },
    // },
    {
      title: "Products",
      htmlBefore: '<i class="material-icons">shopping_cart</i>',
      dev: false,
      to: {
        name: "products"
      },
      pages: [
        {
          title: "Categories",
          dev: false,
          to: {
            name: "products_categories"
          }
        },
        {
          title: "Collections",
          dev: false,
          to: {
            name: "products_collections"
          }
        }
      ]
    },
    {
      title: "Merchants",
      htmlBefore: '<i class="material-icons">store</i>',
      dev: false,
      to: {
        name: "merchants"
      }
    },
    {
      title: "Team",
      htmlBefore: '<i class="material-icons">people</i>',
      dev: false,
      to: {
        name: "team"
      }
    },
    {
      title: "Documents",
      htmlBefore: '<i class="material-icons">folder</i>',
      dev: false,
      to: {
        name: "documents"
      }
    },
    {
      title: "Settings",
      htmlBefore: '<i class="material-icons">settings_applications</i>',
      dev: false,
      to: {
        name: "settings"
      }
    },
    {
      title: "Apps",
      htmlBefore: '<i class="material-icons">apps</i>',
      dev: true,
      to: {
        name: "apps"
      }
    },
    {
      title: "Developer",
      htmlBefore: '<i class="material-icons">code</i>',
      dev: true,
      to: {
        name: "dev"
      }
    }
  ];
}
